import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { body1Bold, colors, spacing } from 'ui/theme';

export const QueryBuilderCSSContainer = styled.div`
  &&&& {
    display: flex;
    flex-direction: column;
    gap: ${spacing.half};
    .cssStateButtons {
      /** css conversion */
      box-shadow: 0;
      justify-content: flex-end;
      position: absolute;
      right: 0;
      text-align: right;
      top: 0;
      transition: box-shadow 0.2s;
    }
  }
`;

export const QueryBuilderContainer = styled.div`
  background: ${colors.white};
  position: relative;
`;

export const CombinatorContainer = styled.div`
  display: flex;
  .cssCombinatorDropdown {
    /** css class replacement */
    font-size: ${pxToRem(16)};
    margin-bottom: ${pxToRem(20)};
  }
  .cssCombinatorSpacer {
    /** css class replacement */
    height: ${pxToRem(45)}; /** size of the querybuilder connector */
  }
`;

export const StyledClonedItems = styled.ul`
  list-style: inside;
  padding-left: ${spacing.threeQuarter};
`;

export const StyledCloneWarningsHeader = styled.p`
  ${body1Bold};
  color: inherit;
`;
